






















































































import Vue from "vue";
import Component from "vue-class-component";
import { Quiz, Subject } from "@/model/ResponseModel";

@Component({
  name: "QuizComponent"
  // Toutes les options de composant sont autorisées ici.
})
export default class QuizComponent extends Vue {
  data: Quiz = this.$store.state.quizzes;

  computeNumberOfResponse(subject: Subject) {
    return subject.questions.filter(value => value.chosenResponse != undefined)
      .length;
  }

  allRespond() {
    return (
      this.data.subjects.filter(
        subject =>
          subject.questions.filter(value => value.chosenResponse == undefined)
            .length == 0
      ).length === this.data.subjects.length
    );
  }

  reset() {
    for (const subject of this.data.subjects) {
      for (const question of subject.questions) {
        question.chosenResponse = undefined;
      }
    }
  }

  goToResult() {
    //Compute score
    const exceptionQuestion = [
      { q1: 4, q2: 5 },
      { q1: 11, q2: 12 }
    ];
    for (const subject of this.data.subjects) {
      subject.score = 0; // if the user came back
      for (const question of subject.questions) {
        if (question.chosenResponse) {
          subject.score += question.chosenResponse;
        }
      }
    }
    //Special case
    const find = this.data.subjects.find(v => v.id === 1);
    if (find) {
      for (const exceptionQuestionElement of exceptionQuestion) {
        const q1 = find.questions.find(
          v => v.id === exceptionQuestionElement.q1
        );
        const q2 = find.questions.find(
          v => v.id === exceptionQuestionElement.q2
        );
        if (q1 && q2 && (q1.chosenResponse != 2 || q2.chosenResponse != 2)) {
          find.counterError++;
        }
      }
      if (find.counterError > 1) {
        find.disable = true;
      }
    }
    const item = localStorage.getItem("data");
    if (item) {
      const parse = JSON.parse(item) as any[];
      const data = {
        data: this.data,
        date: Date.now(),
        id: parse.length + 1
      } as any;
      parse.push(data);
      localStorage.setItem("data", JSON.stringify(parse));
    }
    this.$router.push("result");
  }
}
